export const normalizeEventTypes = (data, role) => {
  if (!data || typeof data !== 'object' || Array.isArray(data)) return [];
  return Object.entries(data).flatMap(([key, value]) => {
    if (typeof value === 'string') return [{ key, label: value, defaultEnabled: true }];
    if (!value || typeof value !== 'object' || typeof value.label !== 'string') return [];
    if (Array.isArray(value.roles) && !value.roles.includes(role)) return [];
    if (value.audience && value.audience !== 'internal') return [];
    return [{ key, label: value.label, defaultEnabled: value.default_enabled !== false }];
  });
};

export const settingsErrorText = (detail, fallback) => {
  if (typeof detail === 'string' && detail.trim()) return detail;
  if (Array.isArray(detail)) return detail.map(item => typeof item?.msg === 'string' ? item.msg : '').filter(Boolean).join(' ') || fallback;
  return fallback;
};